// Small segmented control for $/% toggles and the CDD schedule selector.
// Pure presentation; no shared dependencies.

import React from 'react';

export default function SegmentToggle({ value, onChange, options, testId, ariaLabel }) {
  return (
    <div
      role="radiogroup"
      aria-label={ariaLabel || 'Toggle'}
      data-testid={testId}
      className="inline-flex rounded-md border border-slate-300 bg-white p-0.5 text-xs"
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            data-testid={testId ? `${testId}-${opt.value}` : undefined}
            onClick={() => onChange(opt.value)}
            className={
              'px-3 py-1.5 rounded-[5px] font-medium transition-colors ' +
              (active
                ? 'bg-[#2FA163] text-white shadow-sm'
                : 'text-slate-600 hover:text-[#092825]')
            }
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
